module.exports = __webpack_public_path__ + "static/media/Vector.5bf18610.svg";